import './scss/dropdown.scss'
import {DropdownComponent} from './DropdownComponent'

const DropdownPackage = {
    name: 'UIDropdown',
    configure: function(config) {
        config.addComponent('UIDropdown', DropdownComponent, false, 'DropdownComponent')
    }
}

export {DropdownPackage}
